
import {defineComponent, ref, computed, nextTick, getCurrentInstance} from "vue";
import type {PropType} from "vue"
import type {CronValue, CornItem} from "./cronTypes";
import cornResult from './result.vue';

const __default__ = defineComponent({
  name: "alpCron",
  setup(props,{emit}) {
    const proxy: any = getCurrentInstance()?.proxy;
    // size
    const sizeMap = {
      'small': '12px',
      'default': '14px',
      'large': '16px'
    }
    const textSize = ref(sizeMap[props.size]);
    // 显示文本
    const text = {
      Seconds: {
        name: "秒",
        every: "每一秒钟",
        interval: ["每隔", "秒执行 从", "秒开始"],
        specific: "具体秒数(可多选)",
        cycle: ["周期从", "到", "秒"],
        none: "不指定"
      },
      Minutes: {
        name: "分",
        every: "每一分钟",
        interval: ["每隔", "分执行 从", "分开始"],
        specific: "具体分钟数(可多选)",
        cycle: ["周期从", "到", "分"],
        none: "不指定"
      },
      Hours: {
        name: "时",
        every: "每一小时",
        interval: ["每隔", "小时执行 从", "小时开始"],
        specific: "具体小时数(可多选)",
        cycle: ["周期从", "到", "小时"],
        none: "不指定"
      },
      Day: {
        name: "天",
        every: "每一天",
        intervalWeek: ["每隔", "周执行 从", "开始"],
        intervalDay: ["每隔", "天执行 从", "天开始"],
        specificWeek: "具体星期几(可多选)",
        specificDay: "具体天数(可多选)",
        lastDay: "在这个月的最后一天",
        lastWeekday: "在这个月的最后一个工作日",
        lastWeek: ["在这个月的最后一个"],
        beforeEndMonth: ["在本月底前", "天"],
        nearestWeekday: ["最近的工作日（周一至周五）至本月", "日"],
        someWeekday: ["在这个月的第", "个"],
        none: "不指定"
      },
      Week: ["天", "一", "二", "三", "四", "五", "六"].map(function (e) {
        return "星期" + e
      }),
      Month: {
        name: "月",
        every: "每一月",
        interval: ["每隔", "月执行 从", "月开始"],
        specific: "具体月数(可多选)",
        cycle: ["从", "到", "月之间的每个月"],
        none: "不指定"
      },
      Year: {
        name: "年",
        every: "每一年",
        interval: ["每隔", "年执行 从", "年开始"],
        specific: "具体年份(可多选)",
        cycle: ["从", "到", "年之间的每一年"]
      }
    }
    // 秒
    const second = ref<CornItem>({
      cronEvery: '',
      incrementStart: '3',
      incrementIncrement: '5',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
    })
    // 分
    const minute = ref<CornItem>({
      cronEvery: '',
      incrementStart: '3',
      incrementIncrement: '5',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
    })
    // 小时
    const hour = ref<CornItem>({
      cronEvery: '',
      incrementStart: '3',
      incrementIncrement: '5',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
    })
    // 天
    const day = ref<CornItem>({
      cronEvery: '',
      incrementStart: '1',
      incrementIncrement: '1',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
      cronLastSpecificDomDay: 1,
      cronDaysBeforeEomMinus: '',
      cronDaysNearestWeekday: '',
    })
    // 星期
    const week = ref<CornItem>({
      cronEvery: '',
      incrementStart: '1',
      incrementIncrement: '1',
      specificSpecific: [],
      cronNthDayDay: 1,
      cronNthDayNth: '1',
    })
    // 月份
    const month = ref<CornItem>({
      cronEvery: '1',
      incrementStart: '3',
      incrementIncrement: '5',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
    })
    // 年
    const year = ref<CornItem>({
      cronEvery: '',
      incrementStart: '2017',
      incrementIncrement: '1',
      rangeStart: '',
      rangeEnd: '',
      specificSpecific: [],
    })
    
    // 计算属性
    const secondsText = computed(() => {
      let seconds = '';
      let cronEvery = second.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          seconds = '0';
          break;
        case '1':
          seconds = '*';
          break;
        case '2':
          seconds = second.value.incrementStart + '/' + second.value.incrementIncrement;
          break;
        case '3':
          second.value.specificSpecific.map(val => {
            seconds += val + ','
          });
          seconds = seconds.slice(0, -1);
          break;
        case '4':
          seconds = second.value.rangeStart + '-' + second.value.rangeEnd;
          break;
      }
      if (seconds !== '0' && daysText.value === '?') {
        day.value.cronEvery = "1"
      }
      if (seconds !== '0' && monthsText.value === '?') {
        month.value.cronEvery = "1"
      }
      return seconds;
    })
    const minutesText = computed(() => {
      let minutes = '';
      let cronEvery = minute.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          minutes = '0';
          break;
        case '1':
          minutes = '*';
          break;
        case '2':
          minutes = minute.value.incrementStart + '/' + minute.value.incrementIncrement;
          break;
        case '3':
          minute.value.specificSpecific.map(val => {
            minutes += val + ','
          });
          minutes = minutes.slice(0, -1);
          break;
        case '4':
          minutes = minute.value.rangeStart + '-' + minute.value.rangeEnd;
          break;
      }
      if (minutes !== '0' && daysText.value === '?') {
        day.value.cronEvery = "1"
      }
      if (minutes !== '0' && monthsText.value === '?') {
        month.value.cronEvery = "1"
      }
      return minutes;
    })
    const hoursText = computed(() => {
      let hours = '';
      let cronEvery = hour.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          hours = '0';
          break;
        case '1':
          hours = '*';
          break;
        case '2':
          hours = hour.value.incrementStart + '/' + hour.value.incrementIncrement;
          break;
        case '3':
          hour.value.specificSpecific.map(val => {
            hours += val + ','
          });
          hours = hours.slice(0, -1);
          break;
        case '4':
          hours = hour.value.rangeStart + '-' + hour.value.rangeEnd;
          break;
      }
      if (hours !== '0' && daysText.value === '?') {
        day.value.cronEvery = "1"
      }
      if (hours !== '0' && monthsText.value === '?') {
        month.value.cronEvery = "1"
      }
      return hours;
    })
    const daysText = computed(() => {
      let days = '';
      let cronEvery = day.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          days = '?';
          year.value.cronEvery = '0';
          break;
        case '1':
          days = '*';
          year.value.cronEvery = '1';
          break;
        case '2':
        case '4':
        case '11':
          days = '?';
          break;
        case '3':
          days = day.value.incrementStart + '/' + day.value.incrementIncrement;
          break;
        case '5':
          day.value.specificSpecific.map(val => {
            days += val + ','
          });
          days = days.slice(0, -1);
          break;
        case '6':
          days = "L";
          break;
        case '7':
          days = "LW";
          break;
        case '8':
          days = day.value.cronLastSpecificDomDay + 'L';
          break;
        case '9':
          days = 'L-' + day.value.cronDaysBeforeEomMinus;
          break;
        case '10':
          days = day.value.cronDaysNearestWeekday + "W";
          break
      }
      return days;
    })
    const weeksText = computed(() => {
      let weeks = '';
      let cronEvery = day.value.cronEvery;
      switch (cronEvery.toString()) {
        case '1':
        case '3':
        case '5':
          weeks = '?';
          break;
        case '2':
          weeks = week.value.incrementStart + '/' + week.value.incrementIncrement;
          break;
        case '4':
          week.value.specificSpecific.map(val => {
            weeks += val + ','
          });
          weeks = weeks.slice(0, -1);
          break;
        case '6':
        case '7':
        case '8':
        case '9':
        case '10':
          weeks = "?";
          break;
        case '11':
          weeks = week.value.cronNthDayDay + "#" + week.value.cronNthDayNth;
          break;
      }
      return weeks;
    })
    const monthsText = computed(() => {
      let months = '';
      let cronEvery = month.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          months = '?';
          break;
        case '1':
          months = '*';
          break;
        case '2':
          months = month.value.incrementStart + '/' + month.value.incrementIncrement;
          break;
        case '3':
          month.value.specificSpecific.map(val => {
            months += val + ','
          });
          months = months.slice(0, -1);
          break;
        case '4':
          months = month.value.rangeStart + '-' + month.value.rangeEnd;
          break;
      }
      return months;
    })
    const yearsText = computed(() => {
      let years = '';
      let cronEvery = year.value.cronEvery;
      switch (cronEvery.toString()) {
        case '0':
          years = '';
          break;
        case '1':
          years = '*';
          break;
        case '2':
          years = year.value.incrementStart + '/' + year.value.incrementIncrement;
          break;
        case '3':
          year.value.specificSpecific.map(val => {
            years += val + ','
          });
          years = years.slice(0, -1);
          break;
        case '4':
          years = year.value.rangeStart + '-' + year.value.rangeEnd;
          break;
      }
      return years;
    })
    // cron text
    const cronText: any = computed(() => {
      const cron = `${secondsText.value.trim() || '0'} ${minutesText.value.trim() || '0'} ${hoursText.value.trim() || '0'} ${daysText.value.trim() || '?'} ${monthsText.value.trim() || '?'} ${weeksText.value.trim() || '?'} ${yearsText.value.trim() || ''}`

      if (props.responsive) emit("update:data", cron);
      return cron;
    })
    
    // 获取 cron 表达式
    const getCron = () => {
      return cronText.value;
    }
    // 重置
    const reset = () => {
      [second, minute, hour, day, week, month, year].forEach((item: any) => {
        for (const key in item.value) {
          if (item.value.hasOwnProperty(key)) {
            switch (typeof item.value[key]) {
              case 'object':
                item.value[key] = [];
                break;
              case 'string':
                item.value[key] = ''
                break;
            }
          }
        }
      })
    }
    // 初始化
    const init = (data) => {
      if (data === '' || data === null || data === undefined){
        return;
      }
      // 对表达式进行分割
      const cornList: string[] = data.split(' ').filter(i => i);
      if (cornList.length === 6) {
        let cron = cornList.join(' ') + ' *';
        // emit("update:data", cron);
        init(cron);
        return;
      }
      if (cornList.length !== 7){
        proxy.$message.error('cron 表达式长度不正确！');
        return;
      }
      const cornItem: CornItem[] = [second.value, minute.value, hour.value, day.value, month.value, week.value, year.value]
      // 正则 MAP
      const regMap = {
        '0': 0,
        '\\*': 1,
        '([0-9]{1,4})([\\/])([0-9]{1,4})': 2,
        '\\,': 3,
        '([0-9]{1,4})([\\-])([0-9]{1,4})': 4,
        '([0-9]{1,4}L)': 7,
        'L([\\-])([0-9]{1-4})': 8,
        'LW': 6,
        'L': 5,
        '([0-9]{1,4})W': 9,
        '([0-9]{1,4})([\\#])([0-9]{1,4})': 10,
        '\\?': 11
      }
      cornList.forEach((item: string, idx: number) => {
        for (const regText in regMap) {
          // 正则
          const reg: RegExp = new RegExp(regText, 'ig');
          // 验证是否通过
          const flag = reg.test(item);
          // 匹配到的数据
          let regMatch: any[] = [];
          if (flag) {
            // 秒 分 时 月 年
            if ([0, 1, 2, 4, 6].includes(idx)) {
              switch (regMap[regText]) {
                case 0:
                  cornItem[idx].cronEvery = "0";
                  break;
                case 1:
                  cornItem[idx].cronEvery = '1';
                  break;
                case 2:
                  cornItem[idx].cronEvery = '2';
                  regMatch = item.replace(reg, "$1, $2, $3").split(',')
                  cornItem[idx].incrementIncrement = regMatch[2].trim();
                  cornItem[idx].incrementStart = regMatch[0].trim();
                  break;
                case 3:
                  cornItem[idx].cronEvery = '3';
                  regMatch = item.split(',')
                  cornItem[idx].specificSpecific = regMatch;
                  break;
                case 4:
                  cornItem[idx].cronEvery = '4';
                  regMatch = item.replace(reg, "$1, $2, $3").split(',')
                  cornItem[idx].rangeStart = regMatch[0].trim();
                  cornItem[idx].rangeEnd = regMatch[2].trim();
                  break;
              }
            } else {
              if (idx === 3 && cornItem[idx]) {
                // 日
                switch (regMap[regText]) {
                  case 11:
                    cornItem[idx].cronEvery = '0';
                    break;
                  case 2://
                    cornItem[idx].cronEvery = '3';
                    regMatch = item.replace(reg, "$1, $2, $3").split(',')
                    cornItem[idx].incrementIncrement = regMatch[2].trim();
                    cornItem[idx].incrementStart = regMatch[0].trim();
                    break;
                  case 3:
                    cornItem[idx].cronEvery = '5';
                    regMatch = item.split(',')
                    cornItem[idx].specificSpecific = regMatch;
                    break;
                }
              } else if (idx === 5  && cornItem[idx]) {
                // 周
                switch (regMap[regText]) {
                  case 11:
                    cornItem[idx].cronEvery = '0';
                    break;
                  case 2://
                    cornItem[3].cronEvery = '2';
                    regMatch = item.replace(reg, "$1, $2, $3").split(',')
                    cornItem[idx].incrementIncrement = regMatch[2].trim();
                    cornItem[idx].incrementStart = regMatch[0].trim();
                    break;
                  case 3:
                    cornItem[3].cronEvery = '4';
                    regMatch = item.split(',')
                    cornItem[idx].specificSpecific = regMatch;
                    break;
                }
              }
              // 日 周
              switch (regMap[regText]) {
                case 1:
                  cornItem[idx].cronEvery = '1';
                  break;
                case 5:
                  cornItem[idx].cronEvery = '6';
                  break;
                case 6:
                  cornItem[idx].cronEvery = '7';
                  break;
                case 7:
                  cornItem[idx].cronEvery = '8';
                  regMatch = [parseInt(item)]
                  cornItem[idx].cronLastSpecificDomDay = regMatch[0].trim();
                  break;
                case 8:
                  cornItem[idx].cronEvery = '9';
                  regMatch = item.split('-')
                  cornItem[idx].cronDaysBeforeEomMinus = regMatch[1].trim();
                  break;
                case 9:
                  cornItem[idx].cronEvery = '10';
                  cornItem[idx].cronDaysNearestWeekday = parseInt(item);
                  break;
                case 10:
                  cornItem[3].cronEvery = '11'
                  regMatch = item.replace(reg, "$1, $2, $3").split(',')
                  cornItem[idx].cronNthDayNth = regMatch[0].trim();
                  cornItem[idx].cronNthDayDay = regMatch[2].trim();
                  break;
                case 11:
                  // cornItem[3].cronEvery = cornItem[3].cronEvery;
                  break;
              }
            }
          }
        }
      })
    }

    init(props.data)
    
    return {
      second,
      minute,
      hour,
      day,
      week,
      month,
      year,
      text,
      
      secondsText,
      minutesText,
      hoursText,
      daysText,
      weeksText,
      monthsText,
      yearsText,
      cronText,
  
      textSize,
  
      getCron,
      reset
    }
  },
  props: {
    data: {
      type: String as PropType<string>,
      default: '0 0 0 ? * ? *',
    },
    responsive: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small',
      validator: (val: string) => ['small','default','large'].includes(val)
    }
  },
  components: {
    cornResult
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "e20b9cf2": (_ctx.textSize)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__